import * as React from "react";

import SearchIcon from '@material-ui/icons/Search';

// import { ListItem } from '@material-ui/core/List';
// import RaisedButton from '@material-ui/core/RaisedButton';
// import Subheader from '@material-ui/core/Subheader';
import grey from '@material-ui/core/colors/grey';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

const grey500 = grey[500];

export interface ISearchListItemProps {
    title?: string;
    value?: string;
    searchPlaceholder: string;
    onSearch: (term: string) => void;
}

export class SearchListItem extends React.Component<ISearchListItemProps, any> {
    constructor(props: ISearchListItemProps) {
        super(props);
        this.state = {
            searchPlaceholder: props.searchPlaceholder,
            searchText: props.value || "",
            title: props.title
        };
    }
    private onSearchTextChanged = (e: any) => {
        this.setState({ searchText: e.target.value });
    }
    private onPerformSearch = (e: any) => {
        const { onSearch } = this.props;
        if (onSearch) {
            onSearch(this.state.searchText);
        }
    }
    public componentWillReceiveProps(nextProps: ISearchListItemProps) {
        this.setState({
            searchPlaceholder: nextProps.searchPlaceholder,
            searchText: nextProps.value || "",
            title: nextProps.title
        });
    }

    private onKeyPress = (e: any) => {
        if (e.keyCode === 13) {
            this.onPerformSearch(null);
        }
    }
    private static itemStyle = {
        marginLeft: 20,
        marginRight: 50
    }
    public render() {
        const { title, searchPlaceholder, searchText } = this.state;
        return <>
            {/* {(() => {
                if (title) {
                    return <Subheader>{title}</Subheader>;
                }
                return undefined;
            })()} */}
            <div>
            <div style={{float:"right"}}>
               <IconButton
               onClick={this.onPerformSearch}
             >
             
             <SearchIcon nativeColor={grey500} /></IconButton>
             </div>
                <div style={SearchListItem.itemStyle}>
                
                    <TextField type="search" label={title} 
                    onKeyUp={this.onKeyPress}
                    className="search-input" style={{ width: "100%" }} helperText={searchPlaceholder} 
                    value={searchText} onChange={this.onSearchTextChanged} />
                </div>


             
            </div>
        </>;
    }
}


// WEBPACK FOOTER //
// ./src/components/search-list-item.tsx